/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_Complete_Confirm_DescriptionInputs */

const en_task_reminders_complete_confirm_description = /** @type {(inputs: Task_Reminders_Complete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completing this task will cancel all pending reminders.`)
};

const pt_br2_task_reminders_complete_confirm_description = /** @type {(inputs: Task_Reminders_Complete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao concluir esta atividade, todos os lembretes pendentes serão cancelados.`)
};

/**
* | output |
* | --- |
* | "Completing this task will cancel all pending reminders." |
*
* @param {Task_Reminders_Complete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_complete_confirm_description = /** @type {((inputs?: Task_Reminders_Complete_Confirm_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_Complete_Confirm_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_complete_confirm_description(inputs)
	return pt_br2_task_reminders_complete_confirm_description(inputs)
});